import { Component, ChangeDetectionStrategy, inject, input, computed } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { SipGatewayInfo } from '@generated/models/sip-gateway-info';
import { NotificationService } from '@core/services/notification.service';

@Component({
  selector: 'app-sip-gateway-info',
  standalone: true,
  imports: [ButtonModule, TooltipModule],
  templateUrl: './sip-gateway-info.html',
  styleUrl: './sip-gateway-info.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SipGatewayInfoComponent {
  private notificationService = inject(NotificationService);

  readonly info = input<SipGatewayInfo | null>(null);

  readonly addresses = computed(() => this.info()?.addresses ?? []);
  readonly hasAnything = computed(() => this.addresses().length > 0);

  copyText(text: string): void {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      this.notificationService.showSuccess(
        $localize`:@@common.copied:Copied`
      );
    });
  }
}
